function extensionFromFileName(fileName) {
    return String(fileName || '').replace(/^.*\./, '').toLowerCase();
}

export function checkLoadedFileImage(fileName) {
    return ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'svg'].includes(extensionFromFileName(fileName));
}

export function checkLoadedFileSchedule(fileName) {
    return ['jpeg', 'jpg', 'png', 'gif', 'webp', 'pdf'].includes(extensionFromFileName(fileName));
}
